export default __webpack_public_path__ + "static/media/blurbsWanted.4c1ad12d.png";